/* Vite drops Tailwind's layer-order statement from the app bundle, and this chunk loads
   before it, so the order must be declared here or base ends up before theme */
@layer properties, theme, base, components, utilities;

/* base: merges with Tailwind's preflight, where .glyph out-specifies its `svg` rules, and a
   caller's utilities (hidden, block, align-middle, w-*) still win whatever the stylesheet order */
@layer base {
  .glyph {
    box-sizing: content-box;
    display: inline-block;
    vertical-align: -0.125em;
    overflow: visible;
  }

  .fixedWidth {
    width: 1.25em;
  }

  .spin {
    animation: spin 1s infinite linear;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
